import {
  CreateNotificationDTO,
  NotificationDTO,
} from "@onetutor/shared/dto/notification.dto.ts";
import { onetutor } from "./onetutor";

const notification = onetutor.injectEndpoints({
  endpoints: (builder) => ({
    activeNotifications: builder.query<NotificationDTO[], void>({
      query: () => "notification/active",
      providesTags: ["notification"],
    }),
    notificationSeen: builder.mutation<void, string>({
      query: (id) => ({
        url: `notification/${id}/seen`,
        method: "POST",
      }),
      invalidatesTags: ["notification"],
    }),
    createNotification: builder.mutation<
      NotificationDTO,
      CreateNotificationDTO
    >({
      query: (notification) => ({
        url: "notification",
        method: "POST",
        body: notification,
      }),
      invalidatesTags: ["notification"],
    }),
    getNotifications: builder.query<NotificationDTO[], void>({
      query: () => "notification",
      providesTags: ["notification"],
    }),
    deleteNotification: builder.mutation<void, string>({
      query: (id) => ({
        url: `notification/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["notification"],
    }),
  }),
});

export const {
  useActiveNotificationsQuery,
  useNotificationSeenMutation,
  useCreateNotificationMutation,
  useGetNotificationsQuery,
  useDeleteNotificationMutation,
} = notification;
